const CloseButtonStyle = `
  position: absolute;
  right: 16px;
  top: 16px;
`;

export default CloseButtonStyle;
